import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { TOKEN_NAME } from 'CONSTANTS';

export const AuthRoute = ({component, exact, path, computedMatch, location, ...otherProps})=>{
  if(!localStorage[TOKEN_NAME]) return <Redirect to={{ pathname: `/login`, state: {next: { ...location }}}} />;
  return (
    <Route path={path} exact={exact} component={component} />
  );
};

export default AuthRoute;


// WEBPACK FOOTER //
// ./src/components/routes/AuthRoute.jsx